<template>
  <section class="panel">
    <div class="toolbar">
      <el-input v-model="query.batchNo" placeholder="批次号" clearable style="width:180px" />
      <el-button class="btn-search" icon="el-icon-search" @click="load">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="open">创建批次</el-button>
    </div>
    <el-table :data="page.records" border size="small">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="batchNo" label="批次号" min-width="150" />
      <el-table-column prop="productId" label="产品ID" width="90" />
      <el-table-column prop="quantity" label="数量" width="90" />
      <el-table-column prop="generatedCount" label="已生成" width="90" />
      <el-table-column prop="status" label="状态" />
      <el-table-column label="操作" width="360">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" @click="generateCodes(row)">生成码</el-button>
          <el-button size="mini" class="btn-upload" @click="generateQrcodes(row)">生成二维码</el-button>
          <el-button size="mini" class="btn-download" icon="el-icon-download" @click="exportBatch(row)">导出清单</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="创建防伪码批次" :visible.sync="dialog" width="560px">
      <el-form label-position="top">
        <el-form-item label="批次号"><el-input v-model="form.batchNo" /></el-form-item>
        <el-form-item label="产品 ID"><el-input-number v-model="form.productId" :min="1" /></el-form-item>
        <el-form-item label="数量"><el-input-number v-model="form.quantity" :min="1" :max="10000" /></el-form-item>
        <el-form-item label="出厂日期"><el-date-picker v-model="form.manufactureDate" value-format="yyyy-MM-dd" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import http, { downloadFile } from '../api'

const blankPage = { total: 0, page: 1, size: 10, records: [] }

export default {
  data() {
    return {
      query: {},
      page: { ...blankPage },
      dialog: false,
      form: {}
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.page = await http.get('/admin/code-batches', { params: this.query })
    },
    open() {
      const date = new Date().toISOString().slice(0, 10).replaceAll('-', '')
      this.form = { batchNo: `BATCH${date}${Date.now().toString().slice(-4)}`, quantity: 100, manufactureDate: new Date().toISOString().slice(0, 10) }
      this.dialog = true
    },
    async save() {
      await http.post('/admin/code-batches', this.form)
      this.dialog = false
      this.load()
    },
    async generateCodes(row) {
      const data = await http.post(`/admin/code-batches/${row.id}/generate`)
      this.$message.success(`已生成 ${data.generated} 个防伪码`)
      this.load()
    },
    async generateQrcodes(row) {
      const data = await http.post(`/admin/code-batches/${row.id}/qrcodes`)
      this.$message({
        type: data.queued ? 'success' : 'warning',
        message: data.message || '二维码生成任务已提交，后台处理中，请稍后刷新查看结果',
        duration: 5000
      })
      this.load()
    },
    async exportBatch(row) {
      try {
        await downloadFile(`/admin/code-batches/${row.id}/export-excel`, `anti-code-batch-${row.id}.xlsx`)
      } catch (error) {
        this.$message.error(error.message || '导出失败')
      }
    }
  }
}
</script>
